import React, { Component } from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import Toggle from "material-ui/Toggle";
import { GET_LIST } from "admin-on-rest";
import Chips, { Chip } from "react-chips";
import { DivHeaderActions, DivTitle, DivContent } from "./styled";
import Paper from "material-ui/Paper";
import { pink500, cyan500 } from "material-ui/styles/colors";
import { Card, CardHeader, CardText } from "material-ui/Card";

import {
  DialogIconTemplate,
  TextInput,
  Alignment,
  BlockCounter,
  Counter
} from "./components";
import { SketchColorPicker } from "../../../components";
import { RestApiCollections, RestClient } from "../../../../restClient";

const defaultBorder = {
  type: "solid",
  size: 0,
  color: "#e61919"
};

/** note: change collections with content (slug) 090818*/

class FlatButtonView extends Component {
  constructor(props) {
    super(props);
    const {
      buttonColors,
      labelPosition,
      icon,
      href,
      buttonAlign,
      fullWidth,
      containerPadding,
      text,
      typeButton,
      border,
      urlSlug
    } = props.data.values;
    const chip = urlSlug && urlSlug.value ? [urlSlug] : [];
    this.state = {
      expanded: true,
      icon: icon,
      labelPosition: labelPosition,
      buttonColors: buttonColors,
      containerPadding: containerPadding,
      href: href,
      buttonAlign: buttonAlign,
      fullWidth: fullWidth,
      typeButton: typeButton,
      text: text,
      collections: [],
      chips: chip,
      border: border || defaultBorder
    };
  }
  componentWillMount() {
    // this.getCollectionsList();
    this.getContent();
  }

  getCollectionsList = () => {
    // const { list } = this.state;
    RestApiCollections()
      .then(response => {
        return response.json();
      })
      .then(items => {
        if (items && !items.messages) {
          this.setState({
            collections: items
          });
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  getContent() {
    RestClient(GET_LIST, `contents`, {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "title", order: "ASC" },
      filter: {}
    })
      .then(items => {
        if (items && items.data) {
          let newList = [];

          if (items.data.length > 0) {
            newList = items.data.map(item => {
              return { text: item.title, value: item.slug };
            });
          }

          this.setState({
            collections: newList
          });
        }
      })
      .catch(e => {
        // resolve([]);
      });
  }

  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onUpdateText = value => {
    this.setState({
      text: value
    });
  };
  onUpdateUrl = value => {
    let newHref = this.state.href;
    newHref.url = value;

    this.setState({
      href: newHref
    });
  };
  onItemSelected = value => {
    this.setState({
      icon: value
    });
  };
  onChangeTypeButton = (event, index, value) => {
    this.setState({
      typeButton: value
    });
  };
  onChangeButtonAlign = value => {
    this.setState({
      buttonAlign: value
    });
  };
  onToggleFullWidth = (e, v) => {
    this.setState({ fullWidth: v });
  };
  onToggleActionCollection = (e, v) => {
    let collection = this.state.href;
    collection.isCollection = v;
    this.setState({ href: collection });
  };

  handleContent = chips => {
    if (chips.length > this.state.chips.length) {
      if (this.state.chips.length < 1) {
        this.setState({
          chips: chips
        });
      }
    } else {
      this.setState({
        chips: []
      });
    }
  };

  onChangeTarget = (event, index, value) => {
    const newValue = value === "_blank" ? value : "";
    let newHref = this.state.href;
    newHref.target = newValue;
    this.setState({
      href: newHref
    });
  };
  onChangeTargetCollection = (event, index, value) => {
    let newHref = this.state.href;
    // newHref.collection = value;
    this.setState({
      href: newHref,
      urlSlug: value
    });
  };

  onChangeLabelPosition = (event, index, value) => {
    this.setState({
      labelPosition: value
    });
  };
  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };
  onUpdateColor = (color, type) => {
    let newButtonColor = this.state.buttonColors;
    if (type === "color") {
      newButtonColor.color = color;
    } else if (type === "background") {
      newButtonColor.backgroundColor = color;
    } else if (type === "hover") {
      newButtonColor.hoverColor = color;
    } else if (type === "ripple") {
      newButtonColor.rippleColor = color;
    }
    this.setState({
      buttonColors: newButtonColor
    });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.text = this.state.text;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.labelPosition = this.state.labelPosition;
    newData.values.icon = this.state.icon;
    newData.values.fullWidth = this.state.fullWidth;
    newData.values.href = this.state.href;
    newData.values.typeButton = this.state.typeButton;
    newData.values.border = this.state.border;
    newData.values.urlSlug = this.state.chips;
    localStorage.setItem("FlatButtonView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const ButtonViewContent = JSON.parse(
      localStorage.getItem("FlatButtonView")
    );
    if (ButtonViewContent) {
      const {
        buttonColors,
        labelPosition,
        icon,
        href,
        buttonAlign,
        fullWidth,
        containerPadding,
        text,
        typeButton,
        border,
        urlSlug
      } = ButtonViewContent;
      this.setState({
        icon: icon,
        labelPosition: labelPosition,
        buttonColors: buttonColors,
        containerPadding: containerPadding,
        href: href,
        typeButton: typeButton,
        buttonAlign: buttonAlign,
        fullWidth: fullWidth,
        text: text,
        border: border,
        chips: urlSlug
      });
    }
  };
  onClickSave = () => {
    let newData = this.props.data;
    const slug = this.state.chips;
    newData.values.text = this.state.text;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.buttonAlign = this.state.buttonAlign;
    newData.values.buttonColors = this.state.buttonColors;
    newData.values.labelPosition = this.state.labelPosition;
    newData.values.icon = this.state.icon;
    newData.values.fullWidth = this.state.fullWidth;
    newData.values.href = this.state.href;
    newData.values.typeButton = this.state.typeButton;
    newData.values.border = this.state.border;
    newData.values.urlSlug = slug.length > 0 ? slug[0] : {};
    this.props.onUpdateData(newData);
  };

  updateBorderContent = (values, index) => {
    let { border } = this.state;
    border[index] = values;
    this.setState({
      border: border
    });
  };
  onChangeBorderType = (event, index, value) => {
    let { border } = this.state;
    border["type"] = value;
    this.setState({
      border: border
    });
  };

  render() {
    const { target } = this.state.href;
    const valueTarget = target === "_blank" ? target : "same";
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Flat Button"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              expandable={true}
              style={{ overflowY: "scroll", height: 500 }}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <SelectField
                  floatingLabelText="Type Button"
                  onChange={(event, index, value) =>
                    this.onChangeTypeButton(event, index, value)
                  }
                  value={this.state.typeButton}
                  autoWidth={true}
                  name="typeButton"
                >
                  <MenuItem value={"flat"} primaryText="Flat Button" />
                  <MenuItem value={"raised"} primaryText="Raised Button" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <div>
                  <Toggle
                    label="Full Width"
                    style={{ marginBottom: 10 }}
                    toggled={this.state.fullWidth}
                    onToggle={(e, v) => this.onToggleFullWidth(e, v)}
                  />
                </div>
                <DivTitle>Button Text</DivTitle>
                <TextInput
                  value={this.state.text}
                  onChange={value => this.onUpdateText(value)}
                  name="textButton"
                  title=""
                  fullWidth={true}
                />
                <SelectField
                  floatingLabelText="Label Position"
                  onChange={(event, index, value) =>
                    this.onChangeLabelPosition(event, index, value)
                  }
                  value={this.state.labelPosition}
                  autoWidth={true}
                  name="label position"
                >
                  <MenuItem value={"before"} primaryText="Before" />
                  <MenuItem value={"after"} primaryText="After" />
                </SelectField>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Button Align</DivTitle>
                <Alignment
                  value={this.state.buttonAlign}
                  onChange={value => this.onChangeButtonAlign(value)}
                  title=""
                />
              </Paper>
              <Paper style={{ padding: 10, marginBottom: 10 }} zDepth={1}>
                <DivTitle>Button Color</DivTitle>
                <DivContent>
                  <SketchColorPicker
                    title={"Color"}
                    onUpdateColor={color => this.onUpdateColor(color, "color")}
                    color={this.state.buttonColors.color}
                  />
                  <SketchColorPicker
                    title={"Background"}
                    onUpdateColor={color =>
                      this.onUpdateColor(color, "background")
                    }
                    color={this.state.buttonColors.backgroundColor}
                  />
                  {this.state.typeButton !== "raised" && (
                    <SketchColorPicker
                      title={"Hover"}
                      onUpdateColor={color =>
                        this.onUpdateColor(color, "hover")
                      }
                      color={this.state.buttonColors.hoverColor}
                    />
                  )}
                  {this.state.typeButton !== "raised" && (
                    <SketchColorPicker
                      title={"Ripple"}
                      onUpdateColor={color =>
                        this.onUpdateColor(color, "ripple")
                      }
                      color={this.state.buttonColors.rippleColor}
                    />
                  )}
                </DivContent>
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Action</DivTitle>
                <SelectField
                  floatingLabelText="Target"
                  onChange={(event, index, value) =>
                    this.onChangeTarget(event, index, value)
                  }
                  value={valueTarget}
                  autoWidth={true}
                  name="target href"
                >
                  <MenuItem value={"same"} primaryText="Same Page" />
                  <MenuItem value={"_blank"} primaryText="New Page" />
                </SelectField>
                <Toggle
                  label="Content"
                  style={{ marginBottom: 10 }}
                  toggled={
                    this.state.href.isCollection
                      ? this.state.href.isCollection
                      : false
                  }
                  onToggle={(e, v) => this.onToggleActionCollection(e, v)}
                />
                {!this.state.href.isCollection && (
                  <TextInput
                    value={this.state.href.url}
                    onChange={value => this.onUpdateUrl(value)}
                    name="HrefUrl"
                    title="Url"
                    fullWidth={true}
                  />
                )}
                {this.state.href.isCollection && (
                  <Chips
                    theme={theme}
                    renderChip={(item, index) => (
                      <Chip theme={chipTheme} key={index}>
                        {item.text}
                      </Chip>
                    )}
                    suggestions={this.state.collections}
                    value={this.state.chips}
                    onChange={this.handleContent}
                    placeholder="input Content"
                    renderSuggestion={(item, { query }) => (
                      <div key={item.value}>{item.text}</div>
                    )}
                    uniqueChips={true}
                    suggestionsFilter={(opt, val) => {
                      return (
                        opt.value.toLowerCase().indexOf(val.toLowerCase()) !==
                        -1
                      );
                    }}
                  />
                  // <SelectField
                  //   floatingLabelText="Using Content link"
                  //   onChange={(event, index, value) =>
                  //     this.onChangeTargetCollection(event, index, value)
                  //   }
                  //   value={this.state.urlSlug}
                  //   autoWidth={true}
                  //   name="target content href"
                  // >
                  //   {this.state.collections.map((item, index) => {
                  //     //primaryText={item.name}// for collections
                  //     return (
                  //       <MenuItem
                  //         key={index}
                  //         value={item.slug}
                  //         primaryText={item.title}
                  //       />
                  //     );
                  //   })}
                  // </SelectField>
                )}
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DialogIconTemplate
                  iconItem={this.state.icon}
                  onItemSelected={icon => {
                    this.onItemSelected(icon);
                  }}
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Border</DivTitle>
                <SketchColorPicker
                  title={"Color"}
                  onUpdateColor={color =>
                    this.updateBorderContent(color, "color")
                  }
                  color={this.state.border.color}
                />
                <Counter
                  isDisabled={false}
                  title="Size"
                  onSetValue={value => this.updateBorderContent(value, "size")}
                  value={this.state.border.size}
                  interval={1}
                  subtitle="px"
                  minValue={0}
                />
                <SelectField
                  floatingLabelText="Type"
                  onChange={(event, index, value) =>
                    this.onChangeBorderType(event, index, value)
                  }
                  value={this.state.border.type}
                  autoWidth={true}
                  name="type Border"
                >
                  <MenuItem value={"dotted"} primaryText="Dotted" />
                  <MenuItem value={"dashed"} primaryText="Dashed" />
                  <MenuItem value={"solid"} primaryText="Solid" />
                  <MenuItem value={"double"} primaryText="Double" />
                  <MenuItem value={"groove"} primaryText="Groove" />
                  <MenuItem value={"ridge"} primaryText="Ridge" />
                  <MenuItem value={"inset"} primaryText="Inset" />
                  <MenuItem value={"outset"} primaryText="Outset" />
                  <MenuItem value={"none"} primaryText="None" />
                  <MenuItem value={"hidden"} primaryText="Hidden" />
                </SelectField>
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 136
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

FlatButtonView.propTypes = {
  data: PropTypes.object,
  onUpdateData: PropTypes.func.isRequired
};

FlatButtonView.defaultProps = {
  data: {
    values: {
      urlSlug: {},
      border: {
        type: "solid",
        size: "0px",
        color: "#e61919"
      }
    }
  }
};
const theme = {
  chipsContainer: {
    display: "flex",
    position: "relative",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    font: "13.33333px Ubuntu",
    minHeight: 24,
    alignItems: "center",
    flexWrap: "wrap",
    padding: "2.5px",
    borderRadius: 0,
    ":focus": {
      border: "1px solid #aaa"
    }
  },
  container: {
    flex: 1
  },
  containerOpen: {},
  input: {
    border: "none",
    outline: "none",
    boxSizing: "border-box",
    width: "100%",
    padding: 5,
    margin: 2.5
  },
  suggestionsContainer: {},
  suggestionsList: {
    position: "absolute",
    border: "1px solid #ccc",
    zIndex: 10,
    left: 0,
    top: "100%",
    width: "100%",
    backgroundColor: "#fff",
    listStyle: "none",
    padding: 0,
    margin: 0
  },
  suggestion: {
    padding: "5px 15px"
  },
  suggestionHighlighted: {
    background: "#ddd"
  },
  sectionContainer: {},
  sectionTitle: {}
};

const chipTheme = {
  chip: {
    border: "10px",
    boxSizing: "border-box",
    display: "flex",
    cursor: "pointer",
    textDecoration: "none",
    margin: "4px",
    color: "white",
    padding: "4px 8px 4px 8px",
    outline: "none",
    fontSize: "inherit",
    fontWeight: "inherit",
    position: "relative",
    backgroundColor: cyan500,
    borderRadius: "16px",
    whiteSpace: "nowrap",
    width: "fit-content",
    alignItems: "center",
    float: "left"
  },
  chipSelected: {
    background: "#888"
  },
  chipRemove: {
    color: "white",
    fill: "white",
    height: "24px",
    width: "24px",
    userSelect: "none",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    cursor: "pointer",
    margin: "0px -4px 0px 8px",
    fontSize: "2.2em",

    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: pink500
    }
  }
};

export default FlatButtonView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/FlatButtonView.js